export class ArchiveFormat {
  static readonly ORIGIN = 'ORIGIN';
  static readonly PDF = 'PDF';
  static readonly EXCEL = 'EXCEL';
  static readonly ANNOTED_PDF = 'ANNOTED_PDF';
}
